import { useState, useContext, useMemo } from "react";
import useIsomorphicEffect from "../isomorphic-effect";
import i18Context from "./context";

function useLocale(namespace) {
	const translator = useContext(i18Context);

	const { i18, subscribe, setLanguage } = translator;
	const [language, setLng] = useState(i18.language);

	const $t = useMemo(
		() => i18.getFixedT(i18.language, namespace), //
		[i18.language, namespace],
	);

	useIsomorphicEffect(
		() =>
			subscribe(lng => {
				if (language === lng) return;
				setLng(lng);
			}),
		[setLng, language],
	);

	return [$t, language, setLanguage];
}

export default useLocale;
